import { useEffect, useState } from "react";

const useMediaQuery = (query: string, defaultMatches = false) => {
  const [matches, setMatches] = useState(defaultMatches);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const media = window.matchMedia(query);

    if (media.matches !== matches) setMatches(media.matches);

    const listener = () => setMatches(media.matches);

    media.addEventListener("change", listener);

    return () => media.removeEventListener("change", listener);
  }, [query, matches]);

  return matches;
};

const useTablet = (): { isTablet: boolean } => {
  const isTablet = useMediaQuery("(min-width: 700px) and (max-width: 1099px)");
  return { isTablet };
};

const useMobile = (): { isMobile: boolean } => {
  const isMobile = useMediaQuery("(max-width: 1099px)"); // TODO: temporary, remove on tablet optimization
  return { isMobile };
};

const useDesktop = (): { isDesktop: boolean } => {
  const isDesktop = useMediaQuery("(min-width: 1100px)");
  return { isDesktop };
};

const useNarrowDesktop = (): { isNarrowDesktop: boolean } => {
  const isNarrowDesktop = useMediaQuery(
    "(min-width: 1100px) and (max-width: 1440px)",
  );
  return { isNarrowDesktop };
};

const useWideDesktop = (): { isWideDesktop: boolean } => {
  const isWideDesktop = useMediaQuery("(min-width: 1920px)");
  return { isWideDesktop };
};

export { useMobile, useNarrowDesktop, useWideDesktop, useTablet, useDesktop };
